module.exports = __webpack_public_path__ + "static/media/productsIcons.811a2bf7.svg";